const siteName = 'Starport';
export default siteName;
